export default __webpack_public_path__ + "static/media/btn-stage1-pressed.f8c0d425.png";